module.exports = __webpack_public_path__ + "static/media/number.0334600e.svg";